import {FieldValidator} from './validator.interface';

export function composeFieldValidators<T>(validators: Array<FieldValidator<T>>): FieldValidator<T> {
    return async value => {
        for (const validator of validators) {
            const validatorError = await validator(value);
            if (validatorError) return validatorError;
        }
        return undefined;
    };
}